import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { useSiteSettings } from "../../context/SiteSettingsContext";

const FALLBACK_ROWS = [
  { pritch: "UK 3-6", uk: "3–6", eu: "36–39", us: "4–7" },
  { pritch: "UK 6-9", uk: "6–9", eu: "39–43", us: "7–10" },
  { pritch: "UK 9-12", uk: "9–12", eu: "43–47", us: "10–13" },
];

const SizeGuideDialog = ({ open, onOpenChange }) => {
  const settings = useSiteSettings();
  const rows = (settings?.size_guide?.length ? settings.size_guide : FALLBACK_ROWS) || FALLBACK_ROWS;
  const note =
    settings?.size_guide_note ||
    "Fit tip — Pritch grip socks are designed slim. Size down if between sizes.";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-white border border-line rounded-none max-w-lg p-0"
        data-testid="size-guide-dialog"
      >
        <DialogHeader className="px-6 py-4 border-b border-line">
          <DialogTitle className="font-display uppercase tracking-tight text-xl">
            Size guide
          </DialogTitle>
          <DialogDescription className="sr-only">
            Pritch grip sock UK / EU / US size conversion chart.
          </DialogDescription>
        </DialogHeader>
        <div className="p-6">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-line text-left">
                <th className="py-2 overline">Pritch</th>
                <th className="py-2 overline">UK</th>
                <th className="py-2 overline">EU</th>
                <th className="py-2 overline">US</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr
                  key={`${r.pritch}-${i}`}
                  className={i < rows.length - 1 ? "border-b border-line" : ""}
                >
                  <td className="py-3 font-medium">{r.pritch}</td>
                  <td className="py-3 text-mute">{r.uk}</td>
                  <td className="py-3 text-mute">{r.eu}</td>
                  <td className="py-3 text-mute">{r.us}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="mt-5 text-xs text-mute">{note}</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SizeGuideDialog;
